export interface PlatformIdentity {
  version: string | null
  sha: string | null
}

const EMPTY_PLATFORM_IDENTITY: PlatformIdentity = {
  version: null,
  sha: null,
}

export function parsePlatformIdentity(value: unknown): PlatformIdentity {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return { ...EMPTY_PLATFORM_IDENTITY }
  }

  const payload = value as Record<string, unknown>
  return {
    version: normalizeIdentityValue(payload.version),
    sha: normalizeIdentityValue(payload.sha),
  }
}

export async function fetchPlatformIdentity(
  fetcher: typeof fetch = fetch,
): Promise<PlatformIdentity> {
  try {
    const response = await fetcher('/version.json', { cache: 'no-store' })
    if (!response.ok) return { ...EMPTY_PLATFORM_IDENTITY }
    return parsePlatformIdentity(await response.json())
  } catch {
    return { ...EMPTY_PLATFORM_IDENTITY }
  }
}

export function getShortBuildSha(sha: string | null | undefined): string {
  return sha?.slice(0, 7) ?? ''
}

function normalizeIdentityValue(value: unknown): string | null {
  if (typeof value !== 'string') return null
  return value.trim() || null
}
